"use client";
import styled from "../../../client-utils/styled/index.js";
// import components
import IconButton from "@mui/material/IconButton";
import AvatarAtom from "../../../components/atoms/Avatar/index.js";
const coreComponentName = "SdbAvatarButton";
export const Root = styled(IconButton, {
    name: coreComponentName,
    slot: "Root",
})({
    padding: 0,
});
export const Avatar = styled(AvatarAtom, {
    name: coreComponentName,
    slot: "Avatar",
})({
    width: "100%",
    height: "100%",
});
